import { render, staticRenderFns } from "./TrendPue.vue?vue&type=template&id=7aa51b0b&scoped=true&"
import script from "./TrendPue.vue?vue&type=script&lang=js&"
export * from "./TrendPue.vue?vue&type=script&lang=js&"
import style0 from "./TrendPue.vue?vue&type=style&index=0&id=7aa51b0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa51b0b",
  null
  
)

export default component.exports